import { memo } from 'react'
import { makeStyles } from 'tss-react/mui'
import { PlayArrow } from '@mui/icons-material'

const useStyles = makeStyles()(theme => ({
  root: {
    lineHeight: 0,
    position: 'relative',
    padding: theme.spacing(2),
  },
  rootSmall: {
    lineHeight: 0,
    position: 'relative',
    padding: theme.spacing(0.5),
  },
  circle: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    paddingTop: '100%',
    background: '#FFF',
    borderRadius: '100%',
  },
  icon: {
    position: 'relative',
    zIndex: 2,
    width: 36,
    height: 36,
  },
  iconSmall: {
    position: 'relative',
    zIndex: 2,
    width: 24,
    height: 24,
  },
}))

export interface IPlayIconProps {
  size: 'small' | 'large'
}

const PlayIcon = (props: IPlayIconProps) => {
  const { size } = props
  const { classes } = useStyles()

  return (
    <div className={size === 'small' ? classes.rootSmall : classes.root}>
      <div className={classes.circle} />
      <PlayArrow color="primary" className={size === 'small' ? classes.iconSmall : classes.icon} />
    </div>
  )
}

export default memo(PlayIcon)
